import t from '~/javascripts/utils/translation';
import { observer } from 'mobx-react';

const SystemCampaignDonateByCheck = observer(({ handleClose }) => {
  const internationalGivingHtml = () =>
    t(
      'views.donate_form.system_campaign.donate_by_check.international_giving.body',
      {
        email:
          '<a href="mailto:info@charitywater.org">info@charitywater.org</a>',
      }
    );

  return (
    <div className='donate-by-check modal' id='donate-by-check'>
      <div className='modal-inner mb-2 pb-3'>
        <div className='modal-close' onClick={handleClose} />
        <h2 className='h40 modal-title'>
          {t('views.donate_form.system_campaign.donate_by_check.label')}
        </h2>
        <div className='row text-sm'>
          <div className='large-4 columns'>
            <h5 className='info-label text-sm'>
              {t(
                'views.donate_form.system_campaign.donate_by_check.donate_by_check.label'
              )}
            </h5>
            <p className='info-body whitespace-pre-wrap'>
              {t(
                'views.donate_form.system_campaign.donate_by_check.donate_by_check.body'
              )}
            </p>
            <p
              className='info-note whitespace-pre-wrap'
              dangerouslySetInnerHTML={{
                __html: t(
                  'views.donate_form.system_campaign.donate_by_check.donate_by_check.note'
                ),
              }}
            />
          </div>
          <div className='large-4 columns'>
            <h5 className='info-label text-sm'>
              {t(
                'views.donate_form.system_campaign.donate_by_check.international_giving.label'
              )}
            </h5>
            <p
              className='info-body whitespace-pre-wrap'
              dangerouslySetInnerHTML={{ __html: internationalGivingHtml() }}
            />
            <p className='info-note whitespace-pre-wrap'>
              {t(
                'views.donate_form.system_campaign.donate_by_check.international_giving.note'
              )}
            </p>
          </div>
          <div className='large-4 columns'>
            <h5 className='info-label text-sm'>
              {t(
                'views.donate_form.system_campaign.donate_by_check.donate_stock.label'
              )}
            </h5>
            <p className='info-body whitespace-pre-wrap'>
              {t(
                'views.donate_form.system_campaign.donate_by_check.donate_stock.body'
              )}
            </p>
            <p
              className='info-note whitespace-pre-wrap'
              dangerouslySetInnerHTML={{
                __html: t(
                  'views.donate_form.system_campaign.donate_by_check.donate_stock.note'
                ),
              }}
            />
          </div>
        </div>
        <div className='row address-box'>
          <div className='small-centered columns'>
            <div className='panel text-sm'>
              <div className='address-line'>{t('site.label')}</div>
              <div className='address-line'>
                {t('address.multi_line.street')}
              </div>
              <div className='address-line'>
                {t('address.multi_line.city_state_zip')}
              </div>
              <div className='address-line'>
                {t(
                  'views.donate_form.system_campaign.donate_by_check.address.ein'
                )}
              </div>
              <div className='address-line'>
                {t(
                  'views.donate_form.system_campaign.donate_by_check.address.business_type'
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default SystemCampaignDonateByCheck;
